/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { FormField } from '../../types/formFieldTypes';

export interface CustomFieldsState {
  customFields: FormField[];
  customFieldsLoading: boolean;
  error: string | null;
}

const initialState: CustomFieldsState = {
  customFields: [],
  customFieldsLoading: false,
  error: null,
};

type CustomFieldsLoadingKey = 'customFieldsLoading';

const customFieldSlice = createSlice({
  name: 'customFields',
  initialState,
  reducers: {
    fetchCustomFields(state, _action: PayloadAction<{ orgId: number }>) {
      state.error = null;
    },

    setCustomFields(state, action: PayloadAction<FormField[]>) {
      state.customFields = action.payload;
    },

    setLoading(
      state,
      action: PayloadAction<{ key: CustomFieldsLoadingKey; value: boolean }>,
    ) {
      state[action.payload.key] = action.payload.value;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    clearCustomFields(state) {
      state.customFields = [];
    },
    clearCustomFieldsError(state) {
      state.error = null;
    },
  },
});

export const {
  fetchCustomFields,
  setCustomFields,
  setLoading,
  setError,
  clearCustomFields,
  clearCustomFieldsError,
} = customFieldSlice.actions;

export const customFieldsActions = customFieldSlice.actions;

export default customFieldSlice.reducer;
